import React from "react";

export default function InputNormal({
  className,
  title,
  onChange,
  require,
  error,
  textError,
  placeholder
}) {
  const mgTop = {
    marginTop: "10px",
  };
  function checkRequire(require) {
    if (require) {
      return <span style={{ color: "red" }}>*</span>;
    }
  }
  return (
    <div style={mgTop}>
      <p className={className ? className : "txt-sub-explanation1"}>
        {title} {checkRequire(require)}{" "}
      </p>
      <input
        className="text-field"
        placeholder={ placeholder ? placeholder : title}
        style={mgTop}
        onChange={onChange}
      />
      {error && <p className="txt-show-error-required"> {textError} </p>}
    </div>
  );
}
